import { Drawer } from 'antd';
import classNames from 'classnames';

import IconButton from '../buttons/IconButton';
import { DialogsParentProvider } from '../dialogs/DialogsParentContext';
import { useNewShipmentDrawerStyles } from './NewShipmentDrawer.styles';

export default function NewShipmentDrawer({
  open,
  children,
  onClose,
  header,
  headerRightContent,
  destroyOnHidden = true,
  className,
  ...rest
}) {
  const { styles } = useNewShipmentDrawerStyles();

  return (
    <DialogsParentProvider>
      <Drawer
        rootClassName={classNames(
          'NewShipmentDrawer',
          styles.newShipmentDrawer,
          className
        )}
        closable
        title={
          <>
            {header}
            {headerRightContent && (
              <div className={styles.headerRightContent}>
                {headerRightContent}
              </div>
            )}
          </>
        }
        closeIcon={
          <IconButton
            icon="times"
            className="CloseButton"
            data-subject="drawer"
            data-action="close"
          />
        }
        destroyOnHidden={destroyOnHidden}
        mask
        maskClosable
        open={open}
        onClose={onClose}
        {...rest}
      >
        {children}
      </Drawer>
    </DialogsParentProvider>
  );
}
